import styled from 'styled-components'
import IcoTriangleDown from '../../../assets/icons/ico-triangle-down.png'

export const Input = styled.div`
  width: 91%;
  height: 3rem;
  margin-top: 0.25rem;
  font-weight: 600;
  font-size: 1rem;
  padding:0.8125rem 1.125rem;
  border: 1px solid var(--gray-400);
  border-radius: 0.5rem;
  margin-right: 1.5rem;
  position: relative;
`
export const BoxSelect = styled.div`
  background: var(--gray-200) url("${IcoTriangleDown}") no-repeat center center;
  border: 0;
  position: absolute;
  right: 28px;
  width: 48px;
  height: 3rem;
  top: 0px;
  outline: none;
  cursor: pointer;
  border-radius: 0 8px 8px 0;
`

export const Label = styled.div`
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  background: #E0E0E0 !important;
  color: #212366 !important;
  font-weight: bold !important;
  display: none !important;

  &.in {
    display: flex !important;
  }
`

export const DropdownList = styled.div`
  background-color: #F4F4F4;
  /* border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px; */
  border-radius: 8px;
  position: absolute;
  top: 49px;
  right: 28px;
  z-index: 9;
  width: 91%;
  max-height: calc(60.1px * 4);
  overflow: auto;
  
  ::-webkit-scrollbar {
    width: 10px;
  }
  
  ::-webkit-scrollbar-track {
    background: #f1f1f1;
  }
  
  ::-webkit-scrollbar-thumb {
    background: var(--pink-400);
    border-radius: 5px;
  }

  &.out {
    display: none;
  }
  > div {
    color: var(--gray-800);
    font-size: 18px;
    line-height: 22px;
    padding: 1rem 1rem;
    cursor: pointer;
    &:hover {
      background-color: #eee;
    }
  }
`
